export default __webpack_public_path__ + "static/media/logo.68599634.png";